<template>
  <div class="text-center">
      <v-card>
        <div class="container-fluid">
          <v-row justify="center" class="col-12">
            <v-col cols="12">
              <v-icon @click="cancelForm" class="float-right">mdi-close</v-icon>
              <h1 class="text-center">{{title}}</h1>
            </v-col>
            <v-form
              ref="form"
              v-model="formValid"
            >
              <v-row class="col-12">
                <v-col cols="6">
              <v-text-field
                color="green"
                v-model="form.name"
                prepend-icon="mdi-form-textbox"
                label="Název menu"
                :rules="[rules.required]"
                required
              ></v-text-field>
                </v-col>
                <v-col cols="6">
              <v-text-field
                color="green"
                v-model="form.internalName"
                prepend-icon="mdi-form-textbox"
                label="Interní název menu"
                :rules="[rules.required]"
                required>
              </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    color="green"
                    label="Vyberte typ stravy"
                    prepend-icon="mdi-format-list-bulleted"
                    item-text="name"
                    return-object
                    v-model="form.foodTypes"
                    :rules="[rules.required]"
                    :items="foodTypes"
                    :search-input.sync="search"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    deletable-chips
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    color="green"
                    label="Vyberte denní dobu"
                    prepend-icon="mdi-clock-time-eight-outline"
                    v-model="form.timeTypes"
                    item-text="name"
                    return-object
                    :items="timeTypes"
                    :rules="[rules.required]"
                    :search-input.sync="search"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    deletable-chips
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    color="green"
                    label="Jídla"
                    prepend-icon="mdi-food-fork-drink"
                    v-model="form.foods"
                    :items="filteredFoods"
                    item-text="internalName"
                    item-value="id"
                    :search-input.sync="search"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    deletable-chips
                    :disabled="itemSelectDisabled"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    color="green"
                    label="Pití"
                    prepend-icon="mdi-cup"
                    v-model="form.drinks"
                    :items="filteredDrinks"
                    item-text="internalName"
                    item-value="id"
                    :search-input.sync="search"
                    hide-selected
                    multiple
                    persistent-hint
                    small-chips
                    deletable-chips
                    :disabled="itemSelectDisabled"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="green"
                    v-model="form.price"
                    prepend-icon="mdi-cash"
                    label="Cena"
                    :rules="[rules.required, rules.number]"
                    required>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-file-input
                    color="green"
                    label="Vybrat fotografii"
                    v-model="photo"
                    counter="true"
                    :rules="[rules.maxSize(1000000)]"
                    show-size
                    prepend-icon="mdi-camera">
                  </v-file-input>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="error"
                    label="Alergeny"
                    :value="menuAlergensNames"
                    :search-input.sync="search"
                    return-object
                    prepend-icon="mdi-pill"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
              <v-text-field
                color="green"
                prepend-icon="mdi-weight-gram"
                label="Gramáž"
                :placeholder="weight || ''"
                v-model="form.weight"
                required>
              </v-text-field>
                </v-col>
                <v-col cols="6">
              <v-text-field
                :value="volume"
                color="green"
                disabled
                label="Objem"
                prepend-icon="mdi-cup-water"
                required>
              </v-text-field>
                </v-col>
                <v-col cols="6">
              <v-text-field
                color="green"
                :placeholder="calories || ''"
                v-model="form.calories"
                label="Kalorie"
                prepend-icon="mdi-food"
                required>
              </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    v-model="form.specialOffer"
                    label="Akční nabídka"
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="6">
              <v-checkbox
                v-model="dataChecked"
                label="Data jsou zkontrolována"
                :rules="[rules.checked]"
                required>
              </v-checkbox>
                </v-col>
                <v-col cols="12" class="text-right">
              <v-btn
                :disabled="!formValid || empty || wait"
                color="warning"
                class="mr-4"
                @click="save"
              >
                Zapsat
              </v-btn>
                </v-col>
              </v-row>
            </v-form>
        </v-row>
        </div>
      </v-card>
  </div>
</template>

<script>
import rules from '../../../mixins/rules'
import { asFormString } from '../../../utils/formField'

export default {
  name: 'MenuForm',
  mixins: [rules],
  props: ['item'],
  data () {
    return {
      wait: false,
      alergens: [],
      foodTypes: [],
      timeTypes: [],
      drinks: [],
      foods: [],
      dialog: false,
      search: null,
      form: {
        ...this.item,
        price: asFormString(this.item.price)
      },
      photo: null,
      dataChecked: false,
      formValid: true
    }
  },
  computed: {
    empty () {
      return !(this.form.foods.length || this.form.drinks.length)
    },
    filteredFoods () {
      if (this.itemSelectDisabled) {
        return []
      }
      return this.foods.filter(food => {
        const timeTypes = food.timeTypes || []
        const foodTypes = food.foodTypes || []
        const containsTimeTypes = timeTypes.some(type => {
          const formTimeTypesIds = this.form.timeTypes.map(tt => tt.id)
          return formTimeTypesIds.includes(type.id)
        })
        const containsFoodTypes = foodTypes.some(type => {
          const formFoodTypesIds = this.form.foodTypes.map(ft => ft.id)
          return formFoodTypesIds.includes(type.id)
        })
        return containsTimeTypes && containsFoodTypes
      })
    },
    filteredDrinks () {
      if (this.itemSelectDisabled) {
        return []
      }
      return this.drinks.filter(drink => {
        const timeTypes = drink.timeTypes || []
        const foodTypes = drink.foodTypes || []
        const containsTimeTypes = timeTypes.some(type => {
          const formTimeTypesIds = this.form.timeTypes.map(tt => tt.id)
          return formTimeTypesIds.includes(type.id)
        })
        const containsFoodTypes = foodTypes.some(type => {
          const formFoodTypesIds = this.form.foodTypes.map(ft => ft.id)
          return formFoodTypesIds.includes(type.id)
        })
        return containsTimeTypes && containsFoodTypes
      })
    },
    menuAlergens () {
      if (!this.form.foods.length && !this.form.drinks.length) {
        return []
      }
      const alergensObjs = []
      const drinks = this.form.drinks
        .map(id => this.drinks.find(dr => dr.id === id))
        .filter(Boolean)
      const foods = this.form.foods
        .map(id => this.foods.find(f => f.id === id))
        .filter(Boolean)
      foods.concat(drinks)
        .forEach(item => {
          (item.alergens || []).forEach(alergen => {
            alergensObjs.push(alergen)
          })
        })
      const unique = []
      for (const alergen of alergensObjs) {
        if (!unique.map(item => item.id).includes(alergen.id)) {
          unique.push(alergen)
        }
      }
      if (unique.length) {
        return unique
      }
      // Edit: list row already has menu alergens until foods/drinks catalog finishes loading
      return (this.item.alergens || []).slice()
    },
    menuAlergensNames () {
      return this.menuAlergens
        .map(alergen => alergen.name)
        .join(', ')
    },
    itemSelectDisabled () {
      return !(this.form.timeTypes.length && this.form.foodTypes.length)
    },
    weight () {
      if (!this.foods.length) {
        return ''
      }
      let sum = 0
      const foods = this.form.foods
        .map(id => this.foods.find(f => f.id === id))
        .filter(Boolean)
      for (const food of foods) { sum += +food.weight }
      return sum.toString()
    },
    volume () {
      if (!this.drinks.length) {
        return ''
      }
      let sum = 0
      const drinks = this.form.drinks
        .map(id => this.drinks.find(dr => dr.id === id))
        .filter(Boolean)
      for (const drink of drinks) { sum += +drink.volume }
      return sum.toString()
    },
    calories () {
      if (!this.foods.length && !this.drinks.length) {
        return ''
      }
      let sum = 0
      const drinks = this.form.drinks
        .map(id => this.drinks.find(dr => dr.id === id))
        .filter(Boolean)
      const foods = this.form.foods
        .map(id => this.foods.find(f => f.id === id))
        .filter(Boolean)
      for (const item of foods.concat(drinks)) { sum += +item.calories }
      return sum.toString()
    },
    price () {
      if (!this.foods.length && !this.drinks.length) {
        return ''
      }
      let sum = 0
      const drinks = this.form.drinks
        .map(id => this.drinks.find(dr => dr.id === id))
        .filter(Boolean)
      const foods = this.form.foods
        .map(id => this.foods.find(f => f.id === id))
        .filter(Boolean)
      for (const item of foods.concat(drinks)) { sum += +item.price }
      return sum.toString()
    },
    title () {
      return this.item.id ? 'Upravit menu' : 'Přidat menu'
    }
  },
  methods: {
    cancelForm () {
      this.$emit('formCanceled')
    },
    initialize () {
      this.$http.get('/admin/alergens')
        .then(response => {
          this.alergens = this.keysToCamelCase(response.data)
            .filter(alergen => alergen.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/food-types')
        .then(response => {
          this.foodTypes = this.keysToCamelCase(response.data)
            .filter(type => type.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/times')
        .then(response => {
          this.timeTypes = this.keysToCamelCase(response.data)
            .filter(time => time.active)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/foods')
        .then(response => {
          this.foods = this.keysToCamelCase(response.data)
            .filter(food => food.active && food.visible)
        })
        .catch(err => {
          console.log(err)
        })
      this.$http.get('/admin/drinks')
        .then(response => {
          this.drinks = this.keysToCamelCase(response.data)
            .filter(drink => drink.active && drink.visible)
        })
        .catch(err => {
          console.log(err)
        })
    },
    save () {
      this.wait = true
      this.form.calories = this.form.calories || this.calories
      this.form.weight = this.form.weight || this.weight
      this.form.alergens = this.menuAlergens
      Object.keys(this.form).forEach(key => {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      })
      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/menus${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase(
          {
            ...this.form,
            foods: this.form.foods
              .map(id => this.foods.find(food => food.id === id))
              .filter(Boolean),
            drinks: this.form.drinks
              .map(id => this.drinks.find(drink => drink.id === id))
              .filter(Boolean)
          })
      }
      this.$http(options)
        .then(response => {
          const menuId = response.data.id
          const menuName = response.data.name
          if (this.photo) {
            const formData = new FormData()
            formData.append('image', this.photo, this.photo.name)
            formData.append('menu_id', menuId)
            formData.append('name', menuName)

            const photoOptions = {
              method: 'post',
              url: '/admin/menus/upload',
              data: formData
            }
            this.$http(photoOptions)
              .then(() => {
                this.$emit('data-saved')
              })
              .catch(err => { console.log(err) })
          } else {
            this.$emit('data-saved')
          }
        })
        .catch(err => {
          console.log(err)
          this.wait = false
        })
    }
  },
  watch: {
    'form.foodTypes': function (foodTypes) {
      this.form.drinks = this.form.drinks.filter(drinkId => {
        const drink = this.drinks.find(dr => dr.id === drinkId)
        if (!drink) {
          return
        }
        const intersection = (drink.foodTypes || [])
          .map(FT => FT.id)
          .filter(FTid => foodTypes.map(FT => FT.id).includes(FTid))

        return !!intersection.length
      })

      this.form.foods = this.form.foods.filter(foodId => {
        const food = this.foods.find(dr => dr.id === foodId)
        if (!food) {
          return
        }
        const intersection = (food.foodTypes || [])
          .map(FT => FT.id)
          .filter(FTid => foodTypes.map(FT => FT.id).includes(FTid))

        return !!intersection.length
      })
    },
    'form.timeTypes': function (timeTypes) {
      this.form.drinks = this.form.drinks.filter(drinkId => {
        const drink = this.drinks.find(dr => dr.id === drinkId)
        if (!drink) {
          return
        }
        const intersection = (drink.timeTypes || [])
          .map(TT => TT.id)
          .filter(TTid => timeTypes.map(TT => TT.id).includes(TTid))

        return !!intersection.length
      })

      this.form.foods = this.form.foods.filter(foodId => {
        const food = this.foods.find(dr => dr.id === foodId)
        if (!food) {
          return
        }
        const intersection = (food.timeTypes || [])
          .map(TT => TT.id)
          .filter(TTid => timeTypes.map(TT => TT.id).includes(TTid))

        return !!intersection.length
      })
    }
  },
  created () {
    if (!Array.isArray(this.form.foods)) {
      this.form.foods = []
    }
    if (!Array.isArray(this.form.drinks)) {
      this.form.drinks = []
    }
    if (this.item.foods && this.item.foods.length) {
      this.form.foods = this.item.foods.map(f => f.id)
    }
    if (this.item.drinks && this.item.drinks.length) {
      this.form.drinks = this.item.drinks.map(d => d.id)
    }
    this.initialize()
  }
}
</script>

<style scoped>

</style>
